<template>
  <div class="home">
    <Header />
    <CustomerSelectedStats />
  </div>
</template>

<script>
import Header from "../Common/Header.vue";
import CustomerSelectedStats from "@/components/Statistics/CustomerSelectedStats.vue";

export default {
  name: "CustomerSelectedView",
  components: {
    Header,
    CustomerSelectedStats
  }
};
</script>
